<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div *ngIf="showTable; else formView">
                        <div class="mb-3 d-flex align-items-center justify-content-between">
                            <div>
                                <h4>Job Specification List</h4>
                                <p>Filter:</p>
                                <select id="statusFilter" [(ngModel)]="selectedStatus" (change)="filterByStatus()">
                                    <option value="">All</option>
                                    <option value="MatAllocated">Mat Allocated</option>
                                    <option value="JssCreated">JSS Created</option>
                                </select>
                                
                                
                            </div>
                            <div class="d-md-flex align-items-center justify-content-between">                                    
                                <input type="text" placeholder="Search Customer by name" class="form-control" [(ngModel)]="searchText" (input)="onSearch()">
                            </div>
                        </div>
                        <button  disabled  (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3 mr-2"><i class="feather icon-trash-2"></i></button>
                        <!-- <button *ngIf="selectedItemId2" [routerLink]="'/materialMix/' + selectedItemId2" class="btn btn-outline-danger btn-sm mb-3" role="button" aria-pressed="true">
                            Save & Continue
                        </button> -->
                        <button *ngIf="selectedStatus === 'JssCreated' && selectedItemId2" [routerLink]="'/materialMix/' + selectedItemId2" class="btn btn-outline-danger btn-sm mb-3" role="button" aria-pressed="true">
                            Save & Continue
                        </button>
                        
                        <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                            <table class="table mb-0 table-centered table-bordered">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
                                        <th>Ticket No</th>
                                        <th>Ref No</th>
                                        <th>PO No</th>
                                        <th>Client Name</th>
                                        <th>Folder No</th>
                                        <th>Order Qty(kg)</th>
                                        <th>Materials</th>
                                        <th>Cylinders</th>
                                        <th>CoilWidth</th>
                                        <th>RepeatLength</th>
                                        <th>PrintDirection</th>
                                        <th>TotalGsm</th>
                                        <th (click)="sortColumn('colorNames')">ColorNames<span class="datatable-icon-sort-unset sort-btn"></span></th>
                                        <!-- <th class="text-end">Action</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of filteredJssList">
                                        <td><input type="checkbox" class="rowCheckbox custom-control-input" [attr.data-id]="item._id" id="customCheck{{item._id}}"
                                            [checked]="selectedItemId2 === item._id"
                                            (change)="onCheckboxChange(item)">
                                        </td>
                                        <td>{{item.ticketno}}</td>
                                        <td>{{item.refNo}}</td>
                                        <td>{{item.poNo}}</td>
                                        <td>{{item.clientName}}</td>
                                        <td>{{item.jssfolderno}}</td>
                                        <td>{{item.orderKgs| number: '1.2-2' :'en-US'}}</td>
                                        <td>
                                            <ng-container *ngFor="let material of item.materials">
                                                <br>
                                                
                                                <span>{{ material.material }}</span>, 
                                                <span>{{ material.thickness }} </span>, 
                                                <span>{{ material.width }} </span>, 
                                                <span>{{ material.selectedProcess }}</span>
                                              </ng-container>
                                        </td>
                                        <td>
                                            <span style="font-weight: bold;">Supplier:</span> {{ item.cylinders.supplier }},<br>
                                            <span style="font-weight: bold;">Length:</span> {{ item.cylinders.length }}, <br>
                                            <span style="font-weight: bold;">Circumference:</span> {{ item.cylinders.circumference }}, <br>
                                            <span style="font-weight: bold;">Location:</span> {{ item.cylinders.location }}
                                        </td>
                                        <td>{{item.coilWidth}}</td>
                                        <td>{{item.repeatLength}}</td>
                                        <td>{{item.printDirection}}</td>
                                        <td>{{item.totalGsm}}</td>
                                        <td>{{item.colorNames}}</td>
                                    </tr>
                                </tbody>
                                
                                <!-- <tbody>
                                    <tr *ngFor="let item of jssList">
                                        <td><input type="checkbox" class="rowCheckbox custom-control-input" [attr.data-id]="item._id" id="customCheck{{item._id}}"
                                            [checked]="selectedItemId2 === item._id"
                                            (change)="onCheckboxChange(item)">
                                        </td>
                                        <td>{{item.ticketno}}</td>
                                        <td>{{item.clientName}}</td>
                                        <td>{{item.jssfolderno}}</td>
                                        <td>{{item.orderKgs}}</td>
                                        <td>
                                            <ng-container *ngIf="item.printingMat && item.printingMat.selectedPrintingMat">
                                                <span style="font-weight: bold;">Printing Mat:</span> {{ item.printingMat.selectedPrintingMat }}, {{ item.printingMat.mat1 }} <br>
                                            </ng-container>
                                            <ng-container *ngIf="item.laminatMat1 && item.laminatMat1.selectedLaminatMat1">
                                                <span style="font-weight: bold;">Laminat 1:</span> {{ item.laminatMat1.selectedLaminatMat1 }}, {{ item.laminatMat1.lam1 }} <br>
                                            </ng-container>
                                            <ng-container *ngIf="item.laminatMat2 && item.laminatMat2.selectedLaminatMat2">
                                                <span style="font-weight: bold;">Laminat 2:</span> {{ item.laminatMat2.selectedLaminatMat2 }}, {{ item.laminatMat2.lam3 }} <br>
                                            </ng-container>
                                            <ng-container *ngIf="item.laminatMat3 && item.laminatMat3.selectedLaminatMat3">
                                                <span style="font-weight: bold;">Laminat 3:</span> {{ item.laminatMat3.selectedLaminatMat3 }}, {{ item.laminatMat3.lam5 }}
                                            </ng-container>
                                        </td>
                                        <td>
                                            <span style="font-weight: bold;">Supplier:</span> {{ item.cylinders.supplier }},<br>
                                            <span style="font-weight: bold;">Length:</span> {{ item.cylinders.length }}, <br>
                                            <span style="font-weight: bold;">Circumference:</span> {{ item.cylinders.circumference }}, <br>
                                            <span style="font-weight: bold;">Location:</span> {{ item.cylinders.location }}
                                        </td>
                                        <td>{{item.coilWidth}}</td>
                                        <td>{{item.repeatLength}}</td>
                                        <td>{{item.printDirection}}</td>
                                        <td>{{item.totalGsm}}</td>
                                        <td>{{item.colorNames}}</td>
                                        <td class="text-end">
                                            <button type="button" class="btn btn-outline-dark btn-sm" routerLink="/editjsslist/{{item._id}}" title="Edit Jss"><i class="feather icon-edit"></i></button>
                                            <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteJss(item._id)" title="Delete Jss"><i class="feather icon-trash-2"></i></button>
                                        </td>
                                    </tr>
                                </tbody> -->
                            </table>
                        </div>
                        <!-- <div class="pagination-container">
                            <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems }}</p>
                                </div>
                                <div class="d-flex">
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                                        <i class="feather icon-chevrons-left"></i>
                                    </a>
                                    <ng-container *ngFor="let page of getNumberRange(ceil(totalItems / itemsPerPage))">
                                        <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">{{ page }}</a>
                                        <span *ngIf="page < ceil(totalItems / itemsPerPage)" class="page-number-space"></span>
                                    </ng-container>
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceil(totalItems / itemsPerPage)}">
                                        <i class="feather icon-chevrons-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div> -->

                        <div class="datatable-footer-inner selected-count d-flex justify-content-between">
                            <!-- Display total entries on the left side in bold -->
                            <div class="page-count mt-3">
                              <span class="font-weight-bold">{{ filteredJssList.length }} of {{ totalItems }} total</span>
                            </div>
                            
                            <!-- Pagination controls on the right side -->
                            <div class="pagination mt-3 d-flex justify-content-center">
                              <!-- Previous Page Button -->
                              <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                                <i class="feather icon-chevrons-left"></i>
                              </a>
                              
                              <!-- Page Numbers -->
                              <a *ngFor="let page of getPages()" 
                                 class="pagination-circle" 
                                 [class.active]="currentPage === page" 
                                 (click)="onPageChange(page)">
                                {{ page }}
                              </a>
                              
                              <!-- Next Page Button -->
                              <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" 
                                 [ngClass]="{'disabled': currentPage === getPages()[getPages().length - 1]}">
                                <i class="feather icon-chevrons-right"></i>
                              </a>
                            </div>
                          </div>



                        
                    </div>

                    
                    <ng-template #formView>
                        <div class="mb-4 d-md-flex align-items-center justify-content-between">
                            <div>
                                <h3>Complete Updation info and Save</h3>
                                <p>Kindly check all the information and correct all mistakes and update, then save</p>
                            </div>
                        </div>
                        <div class="form-card">
                            <form (ngSubmit)="submitForm()" [formGroup]="updateJssForm">
                                <div class="row">

                                    <div class="col form-group mb-3">
                                        <label for="clientName" class="form-label">Client Name</label>
                                        <input type="text" formControlName="clientName" id="clientName"
                                            class="form-control" readonly />
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="ticketno" class="form-label">Ticket No.</label>
                                        <input type="text" formControlName="ticketno" id="ticketno" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="jssfolderno" class="form-label">JSS Folder No.</label>
                                        <input type="text" formControlName="jssfolderno" id="jssfolderno"
                                            class="form-control" placeholder="Enter JSS Folder No."/>
                                            <div *ngIf="updateJssForm.get('jssfolderno')?.invalid && (updateJssForm.get('jssfolderno')?.dirty || updateJssForm.get('jssfolderno')?.touched)" class="text-danger">
                                                <div *ngIf="updateJssForm.get('jssfolderno')?.errors?.required">JSS Folder No. is required.</div>
                                            </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="refNo" class="form-label">Ref No.</label>
                                        <input type="text" formControlName="refNo" id="refNo" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="poNo" class="form-label">P.O No.</label>
                                        <input type="text" formControlName="poNo" id="poNo" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="jobName" class="form-label">Job Name</label>
                                        <input type="text" formControlName="jobName" id="jobName" class="form-control"
                                            readonly />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="jobType" class="form-label">Job Type</label>
                                        <input type="text" formControlName="jobType" id="jobType" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="orderKgs" class="form-label">Order Qty</label>
                                        <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="LamType" class="form-label">Lamination Type</label>
                                        <div class="input-group">
                                            <select formControlName="LamType" id="LamType" class="form-control minimal">
                                                <option value="" disabled selected>Select Lam Type</option>
                                                <option value="base">Base</option>
                                                <option value="less">Less</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="printType" class="form-label">Print Type</label>
                                        <div class="d-flex">
                                            <input type="text" formControlName="printType" id="printType"
                                                class="form-control" placeholder="Print Type" />
                                        </div>
                                    </div>
                                    <!-- <div class="col form-group mb-3">
                                        <label for="printDirection" class="form-label">Print Direction</label>
                                <input type="text" formControlName="printDirection" id="printDirection" class="form-control" />
                                    </div> -->

                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="coilWidth" class="form-label">Coil Width</label>
                                        <input type="text" formControlName="coilWidth" id="coilWidth"
                                            class="form-control" readonly placeholder="Coil Width" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="coilod" class="form-label">Coil OD</label>
                                        <input type="text" formControlName="coilod" id="coilod" class="form-control"
                                            readonly placeholder="Coil OD" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="repeatLength" class="form-label">Repeat Length</label>
                                        <input type="text" formControlName="repeatLength" id="repeatLength"
                                            class="form-control" placeholder="Repeat Length"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">STD. INK GSM</label>
                                        <input type="text" formControlName="std" id="std" class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">Liquid Ink</label>
                                        <input type="text" formControlName="liquid" id="liquid" class="form-control"
                                            placeholder="Liquid Ink" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">Ink Type</label>
                                        <input type="text" formControlName="inkType" id="inkType" class="form-control"
                                            placeholder="Ink Type" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="printDirection" class="form-label">Print Direction</label>
                                        <input type="text" formControlName="printDirection" id="printDirection"
                                            class="form-control" placeholder="Print Direction" />
                                    </div>
                                    
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="pouch" class="form-label">Pouch Wt/Pcs</label>
                                        <input type="text" formControlName="pouch" id="pouch" class="form-control"
                                            placeholder="Pouch Wt/Pcs" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="totalGsm" class="form-label">TOTAL GSM</label>
                                        <input type="text" formControlName="totalGsm" id="totalGsm" class="form-control"
                                            placeholder="TOTAL GSM" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="coreType" class="form-label">Core Type</label>
                                        <div class="input-group">
                                            <select formControlName="coreType" id="coreType"
                                                class="form-control minimal">
                                                <option value="" disabled Selected>Select Core Type</option>
                                                <option value="PaperPipe">Paper Pipe</option>
                                                <option value="PVCPipe">PVC Pipe</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">

                                    <div class="col form-group mb-3">
                                        <label for="colorNames" class="form-label">Color Names</label>
                                        <input type="text" formControlName="colorNames" id="colorNames"
                                            class="form-control" placeholder="Eneter Color Names" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="colorNumber" class="form-label">No. of Colors</label>
                                        <select formControlName="colorNumber" id="colorNumber"
                                                class="form-control minimal">
                                                <option value="" disabled Selected>Select No. of Colors</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">

                                    <div class="col form-group mb-3">
                                        <div formGroupName="cylinders">
                                            <label for="cylinders" class="form-label">Cylinders</label>

                                            <div class=" row d-flex">
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder ID</label>
                                                    <input type="text" formControlName="id" id="id" class="form-control"
                                                        placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder Supplier</label>
                                                    <input type="text" formControlName="supplier" id="supplier"
                                                        class="form-control" placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Face Length</label>
                                                    <input type="text" formControlName="length" id="length"
                                                        class="form-control" placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder Circumference</label>
                                                    <input type="text" formControlName="circumference"
                                                        id="circumference" class="form-control" placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder Location</label>
                                                    <input type="text" formControlName="location" id="location"
                                                        class="form-control" placeholder="0" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div formArrayName="materials">
                                        <div *ngFor="let material of materials.controls; let i = index" [formGroupName]="i" class="row">
                                          <div class="col form-group mb-3">
                                            <label for="material" class="form-label">Material</label>
                                            <select formControlName="material" id="material" class="form-select">
                                                <option value="" disabled>Select Material</option>
                                                <option value="CLEAR BOPP">CLEAR BOPP</option>
                                                <option value="MET BOPP">MET BOPP</option>
                                                <option value="PEARL BOPP">PEARL BOPP</option>
                                                <option value="MATT BOPP">MATT BOPP</option>
                                                <option value="CLEAR PET">CLEAR PET</option>
                                                <option value="CT PET">CT PET</option>
                                                <option value="CC PET">CC PET</option>
                                                <option value="CT+CC PET">CT+CC PET</option>
                                                <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                                                <option value="MET PET">MET PET</option>
                                                <option value="MATT PET">MATT PET</option>
                                                <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                                                <option value="PVC SHRINK">PVC SHRINK</option>
                                                <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                                                <option value="CPP MET">CPP MET</option>
                                                <option value="CPP CLEAR">CPP CLEAR</option>
                                                <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                                                <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                                                <option value="LDPE CLEAR">LDPE CLEAR</option>
                                                <option value="LDPE WHITE">LDPE WHITE</option>
                                                <option value="FOIL ALU">FOIL ALU</option>
                                                <option value="WIP">WIP</option>
                                            </select>
                                          </div>
                                          <div class="col form-group mb-3">
                                            <label class="form-label" for="thickness">Thickness (µ)</label>
                                            <input type="text" formControlName="thickness" id="thickness" class="form-control"/>
                                          </div>
                                          <div class="col form-group mb-3">
                                            <label class="form-label" for="width">Width(mm)</label>
                                            <input type="text" formControlName="width" id="width" class="form-control"/>
                                          </div>
                                          <div class="col form-group mb-3">
                                            <label class="form-label" for="process">Process</label>
                                            <select class="form-control" id="process" formControlName="selectedProcess">
                                              <option value="" selected>--Select Process--</option>
                                              <option value="EXTRUSION">EXTRUSION</option>
                                              <option value="PRINTING">PRINTING</option>
                                              <option value="LAMINATION">LAMINATION</option>
                                              <option value="SLITTING">SLITTING</option>
                                              <option value="CUTTING">CUTTING</option>
                                              <option value="PACKING">PACKING</option>
                                              <option value="DISPATCH">DISPATCH</option>
                                              <option value="GLUEING">GLUEING</option>
                                            </select>
                                          </div>
                                          <button type="button" class="btn btn-danger" (click)="removeMaterial(i)">Remove</button>
                                        </div>
                                      </div>
                                      <button type="button" class="btn btn-primary" (click)="addMaterial()">Add More Material</button>
                                </div>

                                <button type="submit" class="btn btn-outline-info">Edit JSS</button>
                            </form>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
